import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { AppLinksService } from '../../api/services/app-links.service';
import { BusinessAccountCtaComponent } from '../../partials/components/business-account-cta/business-account-cta.component';
import {
  RelatedPage,
  RelatedPagesComponent,
} from '../../partials/components/related-pages/related-pages.component';

@Component({
  selector: 'app-transaction-monitoring',
  imports: [MatIcon, RouterLink, BusinessAccountCtaComponent, RelatedPagesComponent],
  templateUrl: './transaction-monitoring.component.html',
  styleUrl: './transaction-monitoring.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TransactionMonitoringComponent {
  protected readonly appLinks = inject(AppLinksService);

  protected readonly relatedPages: RelatedPage[] = [
    {
      link: '/aml-check',
      anchor: 'Online AML check for a single wallet',
      text: 'When you only need to clear one counterparty before a trade, a settlement or a payout.',
    },
    {
      link: '/aml-api',
      anchor: 'AML API for crypto screening',
      text: 'Feed monitored wallets and screening results into your own systems through a single integration.',
    },
    {
      link: '/solutions/crypto-exchange',
      anchor: "AML for crypto exchanges",
      text: "What continuous watch looks like on an exchange, where deposits and withdrawals arrive around the clock.",
    },
  ];
}
